<template lang="pug">
.odds-group
  template(v-if="mmoOdds")
    template(v-if="!!mmoDetails['ou'] ")
      template(v-for="(det, ind) in mmoDetails['ou']")
        template(v-if="det && det[11] != 0 && det[12] != 0 && det[11] != '' && det[12] != ''")
          oddsItemMMO(:odds="det" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="ind" :details="mmoDetails" homeAway="1" pos=23)
        template(v-else)
          OddsDisabled
          
        template(v-if="det && det[11] != 0 && det[12] != 0 && det[11] != '' && det[12] != ''")
          oddsItemMMO(:odds="det" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" :count="ind" :details="mmoDetails" homeAway="2" pos=23)
        template(v-else)
          OddsDisabled
  template(v-else)
    template(v-if="!!details['ou'] ")
      template(v-for="(det, ind) in details['ou']")
        template(v-if="det && det[11] != 0 && det[12] != 0 && det[11] != '' && det[12] != ''")
            OddsItem(:odds="det" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="ind" :details="details" homeAway="1")
        template(v-else)
            OddsDisabled
            
        template(v-if="det && det[11] != 0 && det[12] != 0 && det[11] != '' && det[12] != ''")
            OddsItem(:odds="det" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" :count="ind" :details="details" homeAway="2")
        template(v-else)
            OddsDisabled

</template>
<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import oddsItemMMO from "@/components/mobile/main/xitem/oddsItemMMO";

export default {
  components: {
    OddsItem,
    OddsDisabled,
    oddsItemMMO
  },
  mixins: [mixinHDPOUOdds],
  methods: {
    toggleMoreMarkets() {
      this.$emit("toggle-more-markets");
    },
  }
};
</script>
